import { v4 } from 'uuid';
import { WorkExperienceFromLinkedIn } from '../../shared/types';
import { CompanyStatus, EmploymentType, WorkExperience } from '../../../../gql-operations/gql-generated';

export const parseImportedWorkExperiences = (workExperiences?: WorkExperienceFromLinkedIn[] | null): WorkExperience[] =>
    workExperiences?.map((workExperience) => {
        const { company, startDate, endDate, title, description, skills } = workExperience;
        return {
            company: {
                id: company.id || '',
                logo: company.logoUrl || '',
                inFortuneList: false,
                status: CompanyStatus.FromLinkedin,
                description: '',
                industry: company.industry || '',
                name: company.name,
            },
            startDate: new Date(startDate).valueOf(),
            endDate: endDate ? new Date(endDate).valueOf() : undefined,
            employmentType: EmploymentType.Unspecified,
            currentJob: !endDate,
            id: v4(),
            title,
            description,
            skills,
        };
    }) || [];
